import { createFileRoute, Link } from "@tanstack/react-router";
import { Mail, Phone } from "lucide-react";
import { Arrow } from "@/components/icons";
import { routeHead } from "@/components/seo";
import { pageMeta, site, isConfirmed, LAUNCH_CONFIRM } from "@/content";
import { TiltCard } from "@/components/motion";

const ROUTE = "/contact";
export const Route = createFileRoute("/contact")({
  head: () => routeHead(ROUTE),
  component: Page,
});
function Page() {
  const p = pageMeta(ROUTE)!;
  const email = isConfirmed(site.contact.email) ? site.contact.email : null;
  const phone = isConfirmed(site.contact.phone) ? site.contact.phone : null;
  return (
    <div className="bg-background text-foreground">
      <section className="border-b border-line">
        <div className="mx-auto max-w-4xl px-6 py-20">
          <h1 className="hero-enter mt-4 font-serif text-4xl leading-[1.1] text-ink sm:text-5xl">
            {p.h1}
          </h1>
          <p className="hero-enter-delay mt-6 text-lg leading-relaxed text-ink/80">
            The fastest way in is a Strategic Finance Review with Jamee: one conversation to find
            out what's working, what's not, and how much help you actually need.
          </p>
          <div className="hero-enter-delay mt-8 flex flex-wrap gap-3">
            <Link to={site.primaryCta.href} className="btn-primary">
              {site.primaryCta.label}
              <Arrow className="h-4 w-4" />
            </Link>
            <Link to={site.secondaryCta.href} className="btn-secondary">
              {site.secondaryCta.label}
            </Link>
          </div>

          <div className="stagger mt-14 grid gap-6 sm:grid-cols-2">
            <TiltCard className="card-premium p-6">
              <Mail className="h-5 w-5 text-teal" />
              <p className="mt-3 text-xs font-medium text-subtle">Email</p>
              <p className="mt-1 font-medium text-ink">
                {email ? (
                  <a href={`mailto:${email}`} className="link-underline hover:text-teal">
                    {email}
                  </a>
                ) : (
                  <span className="italic text-subtle">{LAUNCH_CONFIRM}</span>
                )}
              </p>
            </TiltCard>
            <TiltCard className="card-premium p-6">
              <Phone className="h-5 w-5 text-teal" />
              <p className="mt-3 text-xs font-medium text-subtle">Telephone</p>
              <p className="mt-1 font-medium text-ink">
                {phone ? (
                  <a
                    href={`tel:+61${phone.replace(/^0/, "").replace(/\s/g, "")}`}
                    className="link-underline hover:text-teal"
                  >
                    {phone}
                  </a>
                ) : (
                  <span className="italic text-subtle">{LAUNCH_CONFIRM}</span>
                )}
              </p>
            </TiltCard>
          </div>
        </div>
      </section>
    </div>
  );
}
